import { FC } from 'react';
import { Participant, Team } from '@frx/frx-services';
import { useDisclosure } from '@chakra-ui/react';
import { ToolsList } from './ToolsList';
import { Announcement } from './Announcement';
import { TeamGoal } from './TeamGoal';
import { ManageCoCaptains } from './co-captain';
import { CustomTeamUrl } from './CustomTeamUrl';
import { StepButton } from '../../../../components';
import {
  Copy,
  EditPencilOutline,
  MegaPhoneOutline,
  Partner,
} from '../../../../assets';

export interface CaptainToolsProps {
  teamData: Team;
  teamMembers: Participant[];
}

export const CaptainTools: FC<CaptainToolsProps> = ({
  teamData,
  teamMembers,
}) => {
  const {
    isOpen: announcementOpen,
    onOpen: onAnnouncementOpen,
    onClose: onAnnouncementClose,
  } = useDisclosure();
  const {
    isOpen: teamGoalOpen,
    onOpen: onTeamGoalOpen,
    onClose: onTeamGoalClose,
  } = useDisclosure();
  const {
    isOpen: teamShortcutOpen,
    onOpen: onTeamShortcutOpen,
    onClose: onTeamShortcutClose,
  } = useDisclosure();
  const {
    isOpen: manageCaptainsOpen,
    onOpen: onManageCaptainsOpen,
    onClose: onManageCaptainsClose,
  } = useDisclosure();

  return (
    <ToolsList>
      <StepButton
        label="Share a team-wide announcement"
        iconLeft={MegaPhoneOutline}
        onClick={onAnnouncementOpen}
        h="76px"
      />
      {announcementOpen && (
        <Announcement isOpen={announcementOpen} onClose={onAnnouncementClose} />
      )}
      <StepButton
        h="76px"
        label="Change team goal"
        iconLeft={EditPencilOutline}
        onClick={onTeamGoalOpen}
      />
      {teamGoalOpen && (
        <TeamGoal
          teamGoal={teamData?.goal}
          isOpen={teamGoalOpen}
          onClose={onTeamGoalClose}
        />
      )}
      <StepButton
        h="76px"
        label="Change team page URL"
        iconLeft={Copy}
        onClick={onTeamShortcutOpen}
      />
      {teamShortcutOpen && (
        <CustomTeamUrl
          isOpen={teamShortcutOpen}
          onClose={onTeamShortcutClose}
        />
      )}
      <StepButton
        h="76px"
        label="Promote a co-captain"
        iconLeft={Partner}
        onClick={onManageCaptainsOpen}
      />
      {manageCaptainsOpen && (
        <ManageCoCaptains
          teamMembers={teamMembers || []}
          isOpen={manageCaptainsOpen}
          onClose={onManageCaptainsClose}
        />
      )}
    </ToolsList>
  );
};
